<template>
  <div>
            <!-- WEB-->
        <v-app-bar
            app
            clipped-left
            light
            color="white"
            class="roma-app-bar"
            :class="`app-bar-${$route.name}`"
            elevation="3"
            style="box-shadow: 0 3px 6px rgba(0,0,0,.06)!important; z-index: 999 !important;"
        >
            <!-- desktop -->
            <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->

            <!-- brand-logo -->
            <div
                class="header-wrapper 
                d-flex 
                justify-space-between 
                align-center"
            >
                <div class="hidden-md-and-up">
                    <router-link
                        to=""
                        class="brand-logo mr-2"
                        style="cursor: default !important;"
                    >

                            <!-- :src="logoRoma"
                            :lazy-src="logoRoma" -->
                        <img
                            src="@/assets/images/logo-roma.svg"
                            class=""
                            alt=""
                        />
                    </router-link>
                </div>

                <div
                    class="
                    left-side
                    justify-space-between 
                    align-center
                    hidden-sm-and-down"
                >
                    <router-link
                        to=""
                        class="brand-logo ml-12 offset-6"
                        style="cursor: default !important;"
                    >
                     <!-- :src="logoRoma"
                            :lazy-src="logoRoma" -->
                        <img
                            src="@/assets/images/logo-roma.svg"
                            class=""
                            alt=""
                        />
                    </router-link>

                    <!-- title -->
                    <v-toolbar-title class="roma-toolbar-title ml-16">
                        Encuestas
                    </v-toolbar-title>
                </div>

            <!--
              <v-btn class="hidden-md-and-up btn-done text-center text-capitalize"
                    v-if="getEnablePdfPoll && !getPollDone"
                    color="white"
                    outlined
                    rounded
                    @click="donePoll"
                    :disabled="disable">
                <span v-if="!disable">Enviar</span>
                <span v-else>Procesando...</span>
              </v-btn>
            -->
                <!-- information block -->
                <!-- v-if="$route.name !== 'ErrorPage'" -->
                <div
                    class="
                    d-flex
                    align-center
                    justify-space-between 
                    information-wrapper
                    "
                    v-if="$route.name !== 'ErrorPage'"
                >
                    <!-- information -->
                    <div
                        class="user align-center d-flex mr-5"
                        v-if="getUserData.institutionContext"
                    >
                        <div
                            class="user__icon mr-5
                            d-none d-sm-flex"
                        >
                            <v-img
                                :src="
                                    `https://plataforma.romacl.com/LogoInstitucion?id=${getUserData.institutionContext.identificationCode}`
                                "
                                :lazy-src="
                                    `https://plataforma.romacl.com/LogoInstitucion?id=${getUserData.institutionContext.identificationCode}`
                                "
                                width="30px"
                            ></v-img>
                        </div>
                        <div
                            class="user__information
                            text-caption
                            text-sm-body-1
                            hidden-sm-and-down"
                        >
                            <p clasS="user__name text-uppercase ">
                                {{
                                    getUserData.institutionContext.identificationCode
                                }}-{{ getUserData.institutionContext.name }}
                            </p>
                            <p
                                class="user__period cardTitle--text text-uppercase"
                            >
                                AÑO ESCOLAR
                                {{ getUserData.institutionContext.yearSelected }}
                            </p>
                        </div>
                    </div>
                    <!-- User -->
                    <div
                        v-if="getLogged"
                        class="d-flex 
                        justify-end
                        roma-app-bar__avatar-wrapper"
                        @click="handleLogout()"
                        title="Cerrar Sesión"
                    >
                        <div
                            class="text-right
                            text-caption
                            text-sm-body-1"
                        >
                            <p class="roma-app-bar__name text-capitalize">
                                {{ romaFullName }}
                            </p>
                            <p class="roma-app-bar__grade">
                                {{ section }}
                            </p>
                        </div>
                        <v-avatar
                            color="white"
                            class=" d-sm-block roma-app-bar__avatar ml-4"
                        >
                            <img
                                src="@/assets/images/avatar_default.png"
                                alt="John"
                            />
                        </v-avatar>
                    </div>
                    <div
                        class="logout"
                        v-if="showLogout"
                        @click="logout()"
                        v-click-outside="closeLogout"
                    >
                        <span>Cerrar sesión</span>
                    </div>
                </div>
            </div>
        </v-app-bar>

  </div>
</template>

<script>
  import {mapActions, mapGetters} from "vuex";

export default {
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      disable: false,
      showLogout: false,

    };
  },
  computed: {
    ...mapGetters({
      info: "getInformation",
      getNotFound: "getNotFound",
      getEnablePdfPoll: "getEnablePdfPoll",
      totalQuestion: "getquantityQuestions",
      questionAndAnswered: "getQuestionsAndAnswered",
      questionsAnswered: "getQuestionsAnswered",
      questions: "getQuestions",
      idMedicionAsignada: "getMA",
      getPollDone: "getPollDone",
      getUserData: "getUserData",
      getLogged:"getLogged",
      getPolls: "getPolls"

    }),
     romaFullName() {
            if (
                typeof this.getUserData.fullName !== "undefined" &&
                this.getUserData && this.getUserData.fullName !== null
            ) {
                return typeof this.getUserData.fullName !== "undefined"
                  // upercase
                    ? this.getUserData.fullName.toUpperCase()
                    : "Usuario";
            } else if (typeof this.getUserData.userName !== "undefined" &&
              this.getUserData && this.getUserData.userName !== null) {
                return this.getUserData.userName !== null
                    ? this.getUserData.userName
                    : "Usuario";
            } else {
                return "Usuario";
            }
        },
    section() {
            return this.getUserData.abreviaturaSeccion;
        },
     logoRoma() {
            if (this.getUserData.institutionContext) {
                return typeof this.getUserData.institutionContext.implementerCode !==
                    "undefined"
                    ? `${process.env.VUE_APP_ROMA_WEB}/LogoInstitucion?id=${this.getUserData.institutionContext.implementerCode}`
                    : `${process.env.VUE_APP_ROMA_WEB_ASSETS}/img/logo-roma.svg`;
            } else {
                return `${process.env.VUE_APP_ROMA_WEB_ASSETS}/img/logo-roma.svg`;
            }
      }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    ...mapActions({
      toastSuccess: "toastSuccess",
      toastError: "toastError",
      sendPoll: "sendPoll",
      setPollDone: "setPollDone",
      setLoadedPdf: "setLoadedPdf",
      resetUser: "resetUser",
      setLogged:"setLogged",
      resetAllPoll: "resetAllPoll"

    }),
    async donePoll() {
      if(this.questionsAnswered.length < this.totalQuestion) {
        const reduce = this.totalQuestion - this.questionsAnswered.length;
        this.toastError({title: "Completar la encuesta", message: `Faltan ${reduce} preguntas por responder` });
      } else {
        this.disable = true;
        const answers = {
          "idMedicionAsignada": this.idMedicionAsignada ,
          "answerQuestionList": this.questionAndAnswered,
          "idPersona":  this.getUserData && this.getUserData.personId ? this.getUserData.personId : null,
            // "idSeccion": this.getPolls[0] && this.getPolls[0].sectionTO.sectionId ? this.getPolls[0].sectionTO.sectionId : null,
            "idSeccionOrigen": this.getPolls[0] && this.getPolls[0].idSeccionOrigen,
            "tipoPerfil":this.getPolls[0] && this.getPolls[0].perfil,
            "userName":this.getUserData && this.getUserData.userName ? this.getUserData.userName : null
        }

        
        await this.sendPoll({answers: answers})
        .then(response => {
            if(response.status === 200 || response == "Encuesta ya fue enviada"){
                console.log('SetPOLLDONE')
                this.setPollDone({pollDone: true});
            }
            if(response.status === 200) {
                this.disable = false;
                this.isDone = true;
            } else {
                this.disable = false;
                if(response == "Encuesta ya fue enviada"){
                    this.isDone = true;
                }else{
                    this.toastError({title: "Error", message: response });
                }
            }
        })
        
      }
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    handleLogout() {
      this.showLogout = !this.showLogout;
    },
    logout() {
      this.resetUser();
      this.resetAllPoll();

      // add a timer to wait 1 sec
      setTimeout(() => {
        window.location.href = process.env.VUE_APP_ROMA_LOGOUT_CAS;
      }, 500);

    },
    closeLogout() {
    this.showLogout = false;
    },
  }
};
</script>

<style lang="scss">

.btn-done {
  background: #3a8fce !important;
  border: none;
  top: 30px;
  right: -13px;
  transform: translate(-50%, -50%);
  position: absolute !important;
}
.mdi-menu {
    color: transparent !important;
}

.header-wrapper {
    width: 100%;
}
.roma-app-bar {
    z-index: 100;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.06) !important;
    .left-side {
        display: flex;
    }
    .brand-logo {
        img {
            width: 95px;
            height: 40px;
        }
    }
    .logout {
        position: absolute;
        padding: 10px 15px;
        background: #ffffff;
        top: 70px;
        right: 10px;
        width: 150px;
        border-radius: 7px !important;
        box-shadow: 0 2px 19px #00000042 !important;
        transition: box-shadow 0.5s ease;
        height: max-content;
        text-align: center;
        cursor: pointer;
        z-index: 150;
    }

    &__avatar-wrapper {
        margin-left: 70px;
        cursor: pointer;
    }

    @media (max-width: 959px) {
        .information-wrapper {
            width: 100%;
        }
        &__avatar-wrapper {
            margin-left: 0px;
            cursor: pointer;
        }
        .user__information {
            line-height: normal !important;
        }
    }
    @media (max-width: 599px) {
        &__avatar-wrapper {
            width: 100%;
        }
        &__avatar {
            height: 27px !important;
            min-width: 27px !important;
            width: 27px !important;
            display: block !important;
            // margin-left: auto;
        }
        .text-right {
            line-height: normal !important;
        }
        .user__information {
            line-height: normal !important;
        }
        .brand-logo {
            img {
                width: 48px;
                height: 20px;
            }
        }
    }
}

/*
@media (max-width: 350px) {
  .btn-done {
    left: 25% !important;
  }
}*/
</style>
